import { LinkCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  DeletedModelConceptHierarchy,
  ModelConceptHierarchy,
} from 'src/containers/ProjectDiagram/types/data';
import { replaceDeletedModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createDeletedModelConceptClass';
import { replaceDeletedModelConceptHierarchyLabelKey } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/createDeletedModelConceptHierarchyLabel';

export const replaceDeletedModelConceptHierarchyKey = (key: string) =>
  key.replace(
    new RegExp(`^${LinkCategory.MODEL_CONCEPT_HIERARCHY}-`),
    `${LinkCategory.DELETED_MODEL_CONCEPT_HIERARCHY}-`
  );

export const createDeletedModelConceptHierarchy = (
  existing: ModelConceptHierarchy,
  deletedKeys: Set<string>
): DeletedModelConceptHierarchy => ({
  key: replaceDeletedModelConceptHierarchyKey(existing.key),
  from: deletedKeys.has(existing.from)
    ? replaceDeletedModelConceptClassKey(existing.from)
    : existing.from,
  value: existing.value,
  to: deletedKeys.has(existing.to)
    ? replaceDeletedModelConceptClassKey(existing.to)
    : existing.to,
  labelKeys: existing.labelKeys.map(
    replaceDeletedModelConceptHierarchyLabelKey
  ),
  category: LinkCategory.DELETED_MODEL_CONCEPT_HIERARCHY,
  points: existing.points,
});
